import { render, staticRenderFns } from "./ProfitList.vue?vue&type=template&id=a527be84"
import script from "./ProfitList.vue?vue&type=script&lang=js"
export * from "./ProfitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports